import React, { Component, } from 'react'
import PropTypes from 'prop-types'

import './styles.css'

class Input extends Component {
  static propTypes = {
    // eslint-disable-next-line
    google: PropTypes.object.isRequired,
    placeFound: PropTypes.func.isRequired,
    placeHolderText: PropTypes.string,
    // eslint-disable-next-line
    google: PropTypes.object,
  }

  static defaultProps = {
    placeHolderText: 'Enter a location',
  }

  state = {
    editing: false,
  }

  componentDidMount() {
    this.renderAutoComplete()
  }

  placeFound(place) {
    // clear the input
    this.autocomplete.value = ''
    // run placeFound from props
    this.props.placeFound({ place, })
  }

  renderAutoComplete = () => {
    const { google, } = this.props
    if (!google) return
    const autocompleteNode = this.autocomplete
    const autocomplete = new google.maps.places.Autocomplete(autocompleteNode)
    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace()
      if (place.geometry && place.geometry.location) {
        this.placeFound(place)
      }
    })
  }

  render() {
    const { placeHolderText, } = this.props
    return (
      <input
        ref={(c) => {
          this.autocomplete = c
        }}
        type="text"
        placeholder={placeHolderText}
      />
    )
  }
}

export default Input



// WEBPACK FOOTER //
// ./src/components/GoogleMaps/PlaceLookup/Input/index.js